module.exports = __webpack_public_path__ + "assets/images/LC@2x-c9ede5.png";